import type { FieldDiff } from '@fall26/shared'

/**
 * Which fields an update card starts with ticked.
 *
 * This is the single most load-bearing default on the review screen, which is
 * why it lives in its own module with its own test rather than inline in a
 * component. An override row exists precisely because I looked at what Canvas
 * said and decided it was wrong. If "Apply" arrived pre-ticked on that field, a
 * tap I made to accept the other three would silently undo that decision — and
 * the only evidence would be a due date quietly moving back.
 *
 * So: everything the feed proposes starts ticked, EXCEPT anything I authored.
 * Taking a value back from Canvas is still one tap; it just has to be a tap
 * about that field.
 */
export function defaultCheckedFields(diffs: readonly FieldDiff[]): Set<string> {
  return new Set(diffs.filter((diff) => !diff.overridden).map((diff) => diff.field))
}

/** Toggling one field, without mutating the set the component is holding. */
export function toggleField(current: ReadonlySet<string>, field: string): Set<string> {
  const next = new Set(current)
  if (next.has(field)) next.delete(field)
  else next.add(field)
  return next
}
